import React, { useState } from 'react'
import { AiFillCaretDown } from 'react-icons/ai'
import classNames from 'classnames'
import { FlexColumn, FlexRow } from '../Containers'
import styles from './Collapse.module.scss'

interface Props {
  header: React.ReactNode
  gap?: string | number
  hasArrow?: boolean
  defaultOpen?: boolean
  disabled?: boolean
}

const Collapse: React.FC<Props> = ({
  header,
  children,
  gap,
  hasArrow,
  defaultOpen,
  disabled,
}) => {
  const [isActive, setActive] = useState(Boolean(defaultOpen))

  return (
    <FlexColumn gap={typeof gap === 'number' ? `${gap}px` : gap} align="normal">
      <FlexRow
        className={styles.header}
        role="button"
        tabIndex={0}
        align="center"
        justify="space-between"
        onClick={disabled ? () => {} : () => setActive((active) => !active)}
      >
        {header}
        {hasArrow && (
          <AiFillCaretDown
            style={{ transform: `rotate(${isActive ? 180 : 0}deg)` }}
          />
        )}
      </FlexRow>
      <div className={classNames(styles.content, isActive && styles.active)}>
        {children}
      </div>
    </FlexColumn>
  )
}

export default Collapse
